// extracted by mini-css-extract-plugin
export default {"profileArea":"Profile_profileArea__3Ya6s","content":"Profile_content__QbCOE"};